import { render, staticRenderFns } from "./BranchRoleForm.vue?vue&type=template&id=08759358&"
import script from "./BranchRoleForm.vue?vue&type=script&lang=js&"
export * from "./BranchRoleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports